// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import CompanyEmailDomain from "entity/CompanyEmailDomain";

import { RestController, RestRequest } from "./RestController";

export default class CompanyEmailDomainController extends RestController {

    /*
     Adds a new domain to a specified company
     */

    addCompanyDomain(companyDomain: CompanyEmailDomain): Promise<CompanyEmailDomain> {
        let request = new RestRequest("/api/v1/company/domain/create", "POST", companyDomain, undefined);
        return this.request(request, null) as Promise<CompanyEmailDomain>;
    }

    /*
     Changes the status of the domain
     */

    changeDomainStatus(domainId: number, status: number): Promise<CompanyEmailDomain> {
        let request = new RestRequest("/api/v1/company/domain/" + domainId + "/status/" + status + "", "PUT", null, undefined);
        return this.request(request, null) as Promise<CompanyEmailDomain>;
    }

    /*
     Returns a list of the company's domains
     */

    getCompanyDomains(companyId: string): Promise<CompanyEmailDomain[]> {
        let request = new RestRequest("/api/v1/company/" + companyId + "/domains", "GET", null, undefined);
        return this.request(request, null) as Promise<CompanyEmailDomain[]>;
    }

    /*
     Removes domain from a company
     */

    removeCompanyDomain(domainId: number): Promise<void> {
        let request = new RestRequest("/api/v1/company/domain/" + domainId + "", "DELETE", null, undefined);
        return this.requestVoid(request);
    }

}
